import React from "react";

import useScrollToTop from "../../../hooks/useScollToTop";

import UserStats from "./components/UserStats";
import UserFilters from "./components/UserFilters";
import UsersTable from "./components/UsersTable";
import UsersMobileList from "./components/UsersMobileList";
import UserDetailsDrawer from "./components/UserDetailsDrawer";
import UserPagination from "./components/UserPagination";
import UsersSkeleton from "./components/UsersSkeleton";
import UsersEmptyState from "./components/UsersEmptyState";

import { useAdminUsers } from "./hooks/useAdminUsers";

function Users() {
  useScrollToTop();

  const {
    filteredUsers,
    paginatedUsers,
    filters,
    stats,
    selectedUser,
    isDrawerOpen,
    loading,
    refreshing,
    deletingId,
    page,
    totalPages,
    fetchUsers,
    updateFilter,
    resetFilters,
    setPage,
    openUserDrawer,
    closeUserDrawer,
    handleDeleteUser,
  } = useAdminUsers();

  const hasFilters = Boolean(filters.search || filters.roleId);

  return (
    <div className="w-full space-y-6 font-satoshi">
      {loading ? (
        <UsersSkeleton />
      ) : (
        <>
          <UserStats stats={stats} />

          <UserFilters
            filters={filters}
            stats={stats}
            refreshing={refreshing}
            onChange={updateFilter}
            onReset={resetFilters}
            onRefresh={() => fetchUsers({ silent: false })}
          />

          {paginatedUsers.length > 0 ? (
            <>
              <UsersTable
                users={paginatedUsers}
                deletingId={deletingId}
                onOpen={openUserDrawer}
                onDelete={handleDeleteUser}
              />

              <UsersMobileList
                users={paginatedUsers}
                deletingId={deletingId}
                onOpen={openUserDrawer}
                onDelete={handleDeleteUser}
              />

              <UserPagination
                page={page}
                totalPages={totalPages}
                perPage={filters.perPage}
                totalItems={filteredUsers.length}
                onPageChange={setPage}
                onPerPageChange={updateFilter}
              />
            </>
          ) : (
            <UsersEmptyState hasFilters={hasFilters} onReset={resetFilters} />
          )}

          <UserDetailsDrawer
            isOpen={isDrawerOpen}
            user={selectedUser}
            deleting={deletingId === selectedUser?.id}
            onClose={closeUserDrawer}
            onDelete={handleDeleteUser}
          />
        </>
      )}
    </div>
  );
}

export default Users;